import React, {useEffect} from "react";
import {ReceiptRounded} from "@material-ui/icons";
import {IconButton, Tooltip} from "@material-ui/core";
import {useHojasDeRutaService} from "../../services/hooks";
import {useSnackbar} from "notistack";

export const PedidoReciboBtn = (row, hojaDeRuta, initEnabled = false) => {
  const [enabled, setEnabled] = React.useState(initEnabled);
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const HojasDeRutaService = useHojasDeRutaService();

  useEffect(() => {
    if (!initEnabled)
      HojasDeRutaService.existentRecibos(
        row.id,
        hojaDeRuta,
        success => setEnabled(success.data.result.includes(row.id)),
        error => enqueueSnackbar(error, {variant: 'error'})
      );
  }, []);

  const onDownloadRecibo = (idpedido, idhoja) => {
    HojasDeRutaService.getRecibo(
      idpedido,
      idhoja,
      "",
      (file, filename) => {
        const fileURL = URL.createObjectURL(file);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = fileURL;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(fileURL);
      },
      error => enqueueSnackbar(error, {variant: 'error'})
    )
  }

  return (
    <>
      <Tooltip title={'Descargar Remito'}>
          <span>
              <IconButton disabled={!enabled} onClick={(e) => {
                e.stopPropagation();
                onDownloadRecibo(row.id, hojaDeRuta)
              }}>
                  <ReceiptRounded fontSize={"small"}/>
              </IconButton>
          </span>
      </Tooltip>
    </>
  )
}
